import React from 'react';
import PropTypes from 'prop-types';
import { fonts } from '@constants/fonts';
import { FormControlLabel as MUIFormControlLabel, Radio } from '@mui/material';
import { makeStyles, withStyles } from 'tss-react/mui';

// v9 removed Radio/SwitchBase's own `inputProps` prop entirely (now `slotProps.input`) —
// translated here so consumers (e.g. filter-group.js's aria-label) don't need to change.
const RadioWithInputProps = ({ inputProps, slotProps, ...props }) => (
  <Radio
    {...props}
    slotProps={{
      ...slotProps,
      ...(inputProps && { input: { ...inputProps, ...slotProps?.input } })
    }}
  />
);

RadioWithInputProps.propTypes = {
  inputProps: PropTypes.object,
  slotProps: PropTypes.object
};

// Styled Radio to match old material-ui 0.19 sizing
// Only sets icon size - padding should be controlled by consumer
const StyledRadio = withStyles(RadioWithInputProps, {
  root: {
    padding: '9px', // MUI default
    '& .MuiSvgIcon-root': {
      height: '1.0625rem',
      width: '1.0625rem'
    }
  }
});

const useStyles = makeStyles()({
  label: {
    fontSize: fonts.md
  }
});

const RadioButton = props => {
  const { classes } = useStyles();
  const { disabled = false, ...data } = props;

  return (
    <MUIFormControlLabel
      classes={{ label: classes.label }}
      disabled={disabled}
      control={<StyledRadio color="primary" />}
      {...data}
    />
  );
};

RadioButton.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string
};

export { StyledRadio as Radio };
export default RadioButton;
